import { v4 as uuidv4 } from 'uuid';
import type { ChatMessageId, NewChatMessage } from './types';

export const createChatMessage = <T extends NewChatMessage>(
  message: T
): T & { messageId: ChatMessageId } => ({
  ...message,
  messageId: uuidv4(),
});
